<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="detalheLeilao; else carregando">
    <div class="row">
        <div class="col">
            <h3>Detalhes do Leilão <small class="text-muted">(#ID: {{detalheLeilaoFiltrado.idLeilao}})</small></h3>
        </div>
        <div class="col-auto">
            <button class="btn btn-primary" type="button" [routerLink]="['/leilao/leiloes']">Voltar</button>
            <button *ngIf="podeReprovar || podeCancelar" [disabled]="detalheLeilaoFiltrado.estado.id != 1" class="btn btn-light"
                type="button" (click)="reprovar()">{{podeReprovar ? 'Reprovar' : 'Cancelar'}}</button>
        </div>
    </div>
    <ul ngbNav #nav="ngbNav" class="col nav-tabs" (navChange)="onTabChange($event)">
        <li [ngbNavItem]="'detalhes'" id="detalhes" title="detalhes">
            <button ngbNavLink>detalhes</button>
            <ng-template ngbNavContent>
                <div class="row">
                    <div [ngClass]="'bn-form-group ' + (detalheLeilaoFiltrado.sistemaRepasse ? 'col-md-12' : 'col-md-12')">
                        <label><b>Agente financeiro</b></label>
                        <input type="text" class="form-control" name="nomeAgenteFinanceiro"
                            value="{{nomeAgente(detalheLeilaoFiltrado.cnpjAgenteFinanceiro)}}" disabled />
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-4">
                        <label><b>Estado</b></label>
                        <input type="text" class="form-control" name="nomeEstado"
                            value="{{detalheLeilaoFiltrado.estado.nomeEstado}}" disabled />
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label><b>Motivo</b></label>
                        <input type="text" class="form-control" name="motivoEstado"
                            value="{{detalheLeilaoFiltrado.estado.motivoEstado}}" disabled />
                    </div>
                    <div class="bn-form-group col-md-2">
                        <label><b>Id. cobrança</b></label>
                        <div class="input-group">
                            <input type="text" class="form-control" name="idCobranca"
                                value="{{detalheLeilaoFiltrado.idCobranca}}" disabled />
                            <div *ngIf="detalheLeilaoFiltrado.idCobranca">
                                <span class="input-group-text">
                                    <a href="#/cobrancas/{{detalheLeilaoFiltrado.idCobranca}}">
                                        <i class="fa fa-external-link-alt" ngbTooltip="Ver detalhes da cobrança"></i>
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-3">
                        <label><b>Data de envio</b></label>
                        <bn-datepicker name="dataEnvio" [(ngModel)]="detalheLeilaoFiltrado.dataEnvio" disabled>
                        </bn-datepicker>
                    </div>
                    <div class="bn-form-group col-md-3">
                        <label><b>Data Leilão</b></label>
                        <bn-datepicker name="dataRealizacao" [(ngModel)]="detalheLeilaoFiltrado.dataRealizacao" disabled>
                        </bn-datepicker>
                    </div>
                    <div class="bn-form-group col-md-3">
                        <label><b>Data Receb. Leilão</b></label>
                        <bn-datepicker name="dataRecuperacao"
                            [(ngModel)]="detalheLeilaoFiltrado.dataRecebimentoValorArrematado" disabled></bn-datepicker>
                    </div>
                    <div class="bn-form-group col-md-3">
                        <label><b>Valor total leilão</b></label>
                        <input type="text" class="form-control moeda" name="valorRecuperacao"
                            value="{{detalheLeilaoFiltrado.valorRecuperadoLeilao | bnMask:'MOEDA'}}" disabled />
                    </div>
                </div>
            </ng-template>
        </li>

        <li *ngIf="detalheLeilaoFiltrado.historicoEstados?.length > 0" [ngbNavItem]="'historico'" id="historico"
            title="historico">
            <button ngbNavLink>historico</button>
            <ng-template ngbNavContent>
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col">Data</th>
                                <th scope="col">Estado</th>
                                <th scope="col">Motivo</th>
                                <th scope="col">Responsável</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let hist of detalheLeilaoFiltrado.historicoEstados">
                                <td>{{ hist.dataUltimaAtualizacao | date:'dd/MM/yyyy H:mm'}}</td>
                                <td>{{ hist.estado.nomeEstado }}</td>
                                <td>{{ hist.estado.motivoEstado}}</td>
                                <td>{{ hist.nomeUsuarioResponsavel}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </li>
    </ul>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>

    <div class="table-responsive mt-4">
      <table class="table" *ngIf="activeTabId === 'detalhes'">
        <thead>
          <th>#</th>
          <th>Id. operação crédito</th>
          <th>Id. operação agente</th>
          <th>Sist./Contrato</th>
          <th>Valor crédito</th>
          <th>Valor honrado a recuperar antes</th>
          <th>Valor honrado recuperado leilão</th>
          <th>Valor honrado final</th>
        </thead>
        <tbody>
          <tr *ngFor="let item of detalheLeilao; let indexItem = index ">
            <td>{{ indexItem + 1 }}</td>
            <td>{{ item.idOperacao }}</td>
            <td>{{ item.idOperacaoAgente }}</td>
            <td>{{ compareExiste(item) }}</td>
            <td>{{ item.valorCreditoOperacao | bnMask: 'MOEDA' }}</td>
            <td>{{ item.valorHonradoRecuperarAntes | bnMask: 'MOEDA' }}</td>
            <td>{{ item.valorDevidoAoFundo | bnMask: 'MOEDA' }}</td>
            <td>{{ item.valorHonradoFinal | bnMask: 'MOEDA' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

</div>

<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>
